export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-results-fb07fa793f89b5669f49533233b659e0.svg";